import { defineComponent, onMounted, watch } from 'vue';
import { BannerOptions } from '../../../interfaces/props.interfaces';

import Banner from './Banner.class';

export default defineComponent({
	props: {
		containerId: String,
		type: String,
		cssClass: String,
	},
	setup: (props: any) => {
		const bannerOptions = props as BannerOptions;

		const component = new Banner(bannerOptions.containerId, bannerOptions.type, bannerOptions.cssClass);

		watch(component.selectedDiscipline, component.updateBanners.bind(component));

		onMounted(component.mounted.bind(component));

		return {
			selectedDiscipline: component.selectedDiscipline,
			updateBanners: component.updateBanners.bind(component),
		};
	},
});
